import { createConfig, http } from "wagmi";
import { arbitrum, avalanche, base, baseSepolia, polygon } from "wagmi/chains";
import { getDefaultConfig } from "connectkit";

export const config = createConfig(
  getDefaultConfig({
    // Every chain the x402 facilitator can offer an EIP-3009 token on; the
    // server's payment requirements pick which one a payment uses.
    chains: [arbitrum, avalanche, base, polygon, baseSepolia],
    transports: {
      [arbitrum.id]: http(),
      [avalanche.id]: http(),
      [base.id]: http(),
      [polygon.id]: http(),
      [baseSepolia.id]: http(),
    },
    walletConnectProjectId: import.meta.env.VITE_WC_PROJECT_ID || "",
    appName: "x402stack",
    appDescription: "Pay-per-article publishing powered by x402",
    appUrl: "https://x402stack.co.uk",
    appIcon: "https://x402stack.co.uk/favicon.ico",
  }),
);
